<template>
  <div>
    <homelogo />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="alignLeft imgcenter">
        <h1 class="titles">¿Quiénes somos?</h1>
        <p class="parrafos1">
          La fundación PC SHEK Colombia surge como iniciativa de
          responsabilidad social de la empresa PCSHEK Tecnología y
          Servicios SAS, con el desarrollo de sus fundadores, aliados y
          profesionales en TIC nos establecemos como pioneros en
          prácticas de reacondicionamiento atendiendo a las
          necesidades de educación y acceso a tecnología en la primera
          infancia de nuestro país.
        </p>
        <div class="hidden-sm-and-down">
          <v-btn
            @click="onclickreturn()"
            rounded
            color="orange"
            class="white--text r-btn"
            href="#nosotros"
          >Te contamos la historia</v-btn>
        </div>
        <div class="hidden-md-and-up text-center">
          <v-btn
            @click="onclickreturn()"
            rounded
            color="orange"
            class="white--text r-btn"
            href="#nosotros"
          >
            Te contamos
            <br />la historia
          </v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="alignRight">
        <h1 class="titles">Misión</h1>
        <p class="parrafos1">
          Apoyar al desarrollo integral de la familia y primera infancia
          a través de proyectos sociales y ambientales, reutilizando
          los elementos móviles y tecnológicos de baja por
          empresas, hogares y otras instituciones, transformándolos
          en herramientas de desarrollo humano sostenible.
        </p>
        <h1 class="titles">Visión</h1>
        <p class="parrafos1">
          En el año 2022, la Fundación PC Shek Colombia será
          reconocida como una ONG líder en la gestión de
          elementos tecnológicos considerados como obsoletos o
          residuos, transformándolos en recursos útiles 
           al servicio de la primera infancia de nuestro país.
          <!-- Te contamos la historia la primera infancia de nuestro país. -->
        </p>
      </v-col>
    </v-row>
    <br />
    <v-row id="nosotros">
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_1.png"
          ></v-img>
          <h1 class="titles2 alignCenter">
            Gonzalo y Yamile comenzaron con
            este sueño hace más de 15 años.
          </h1>
          <p class="parrafos1 alignCenter">
            Él con su visión de llevar tecnología a lugares y personas
            que no contaban con recursos económicos y ella con su
            vocación de maestra usando las tecnologías de
            información y comunicación -TIC- en estas poblaciones.
          </p>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_1.png"></v-img>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img width="100%" src="@/assets/Nosotros/imagen_parrafo_2.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <div class="alignImgRight">
            <v-img
              class="hidden-sm-and-down"
              width="25%"
              src="@/assets/Nosotros/elemento_parrafo_2.png"
            ></v-img>
          </div>
          <h1 class="titles3 alignCenter">
            Bajo la consigna Recicla, Repara,
            Reusa comenzó un proyecto de vida.
          </h1>
          <p class="parrafos1 alignCenter">
            Con los conocimientos de Gonzalo y la tenacidad de
            Yamile, empezaron a recibir donaciones de monitores,
            CPUs, televisores y cuanto componente tecnológico que
            estuviera arrumado y en desuso en el ático de una casa o
            la bodega de una empresa.
            Para repararlo y darle una segunda oportunidad con una
            persona que lo necesitara.
          </p>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_3.png"
          ></v-img>
          <h1 class="titles alignCenter">
            En el camino surgieron ideas
            innovadoras que le pusieron color a
            la vida de muchas personas.
          </h1>
          <p class="parrafos1 alignCenter">
            “Con la ayuda de un amigo, que era pintor a oleo, junto
            con Yamile que es experta en arte country, diseñabamos y
            pintabamos las tapas y carcasas de los computadores que
            nos donaban. El resultado eran unos computadores de
            colores divinos”
          </p>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_3.png"></v-img>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_4.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_4.png"
          ></v-img>
          <h1 class="titles2 alignCenter">
            Y así comenzaron las iniciativas
            sociales con el fin de impulsar el
            cambio a través de la tecnología.
          </h1>
          <p class="parrafos1 alignCenter">
            “Con el tiempo logramos abrir locales en Patio Bonito,
            Bosa Centro, la Candelaria, El 20 de julio. Llevabamos
            computadores reacondicionados a jardínes infantiles en el
            barrio Patio Bonito de Bogotá, donde no había recursos
            para comprar un computador nuevo”
          </p>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_5.png"
          ></v-img>
          <h1 class="titles3 alignCenter">
            La intención siempre se mantuvo:
            Llevar acceso a tecnología a
            TODOS.
          </h1>
          <p class="parrafos1 alignCenter">
            “Organizabamos torneos de fútbol y regalabamos
            camisetas, con la intención de ayudar y enseñarles a los
            chicos sobre tecnología y la importancia del reciclaje”
          </p>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_5.png"></v-img>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_6.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div class="text-center">
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_6.png"
          ></v-img>
          <h1 class="titles alignCenter">
            Lo más satisfactorio es ver que se
            cambian vidas, no solo se le da una
            segunda oportunidad a los
            computadores reciclados sino a las
            personas a las que se les entregan.
          </h1>
          <br />
          <p class="parrafos1 alignCenter">
            Un señor me decía: “Este computador me sirve para que mi hijo escriba, aprenda, estudie...”
            <br />
            <font class="parrafosSub">José, muncipio de Soacha.</font>
          </p>
          <p class="parrafos1 alignCenter">
            "Gracias a sus computadores, tenemos un gran café internet, mi
            esposo es taxista y ahora yo genero ingresos, desde mi casa!”
            <br />
            <font class="parrafosSub">Sra. Maria, localidad de Bosa.</font>
          </p>
          <p class="parrafos1 alignCenter">
            “Empecé con un computador de PCSHEK mi universidad, no
            tenía dinero en ese tiempo, ahora soy profesional en Diseño,
            trabajo para un periódico muy importante, ¡Gracias!
            <br />
            <font class="parrafosSub">Daniel, localidad de Kennedy.</font>
          </p>
          <p class="parrafos1 alignCenter">
            ”¡Nunca pensamos que nuestro jardín tuviera una sala de
            sistemas! Gracias PCSHEK”.
            <br />
            <font class="parrafosSub">Jardín Infantil nuevo Andalucia, localidad de Bosa.</font>
          </p>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_7.png"
          ></v-img>
          <h1 class="titles2 alignCenter">
            De la intención de ayudar y aportar
            al cambio, surgió un modelo de
            negocio con PCSHEK.
          </h1>
          <p class="parrafos1 alignCenter">
            “La fundación nos llevó a crear una empresa que
            hoy es reconocida como una multinacional con los más
            altos estándares internacionales, ahora queremos volver
            a nuestra escencia”
          </p>
        </div>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_7.png"></v-img>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img src="@/assets/Nosotros/imagen_parrafo_8.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="alignCenter box-center">
        <div>
          <v-img
            class="hidden-sm-and-down"
            width="25%"
            src="@/assets/Nosotros/elemento_parrafo_8.png"
          ></v-img>
          <h1 class="titles3">
            “Los problemas de tecnología se
            empezaron a notar aún más con la
            pandemia”.
          </h1>
          <p class="parrafos1">
            “Nos dimos cuenta que hoy en día no se necesita un
            computador por casa, se necesita un computador
            para cada persona"
            "Así como Coca Cola, quiere ser reconocida por cada
            ser humano en el planeta, así sera PCSHEK,
            su fundación y su visión”
          </p>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-row class="text-center">
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img style="display: inline-block;" max-width="40%" src="@/assets/Nosotros/gonzalo.png"></v-img>
        <h1 class="titles alignCenter">Gonzalo</h1>
        <br />
        <p class="parrafos1 alignCenter">
          Experto en Sistemas e Ingeniería de software,
          con formación en Alta Gerencia Internacional
          de la Universidad de lo Andes. Empresario
          visionario con mas de 15 años de experiencia
          en desarrollo de empresas en los sectores del
          medio ambiente y tecnología, consultor y
          asesor de nuevos proyectos en empresas
          privadas y gobierno nacional.
          Pionero en diseño, implementación y ejecución
          de estándares de Reacondicionamiento
          tecnológico bajo el modelo de economía
          circular, ha posicionado a PCSHEK en mas de
          5 países, entre ellos EEUU.
        </p>
      </v-col>
      <v-col lg="6" md="6" sm="12" cols="12" class="resPadding">
        <v-img style="display: inline-block;" max-width="40%" src="@/assets/Nosotros/yamile.png"></v-img>
        <h1 class="titles alignCenter">Yamile</h1>
        <p class="parrafos1 alignCenter">
          Licenciada en Educación Infantil, Especialista en Tecnologías
          de la Información aplicadas a la educación de la Universidad
          Pedagógica Nacional. Co-Fundadora de PCSHEK y
          representante de la Fundación PC SHEK Colombia.
          Con experiencia en desarrollo de programas educativos
          dirigidos al apoyo de de niños y niñas en edad escolar
          empleando recursos digitales.
          Ha orientado la visión y misión de PCSHEK, por mas de 10
          años con un direccionamiento estratégico en la consecución
          de proyectos que impactan positivamente los ámbitos
          sociales, ambientales y económicos de nuestro país.
          Parte activa en el modelo de Reacondicionmiento y su
          expansion internacional.
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";
export default {
  components: {
    homelogo
  },
  methods: {
    onclickreturn() {
      this.$vuetify.goTo("#nosotros");
    }
  }
};
</script>
<style scoped>
.imglogo {
  position: absolute;
  width: 20%;
  z-index: 99;
}
.v-btn {
  text-transform: none !important;
}
.padre {
  position: relative;
}
.hijo {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 30%;
  margin: auto;
}
.alignImgRight {
  background-position: right;
}
.alignRight {
  text-align: right;
  /* padding-right: 15px; */
  padding-right: 60px;
  padding-left: 60px;
}
.alignLeft {
  padding-right: 60px;
  padding-left: 60px;
  /* p
  adding-left: 15px; */
}
.alignCenter {
  text-align: center;
  padding-right: 60px;
  padding-left: 60px;
}
.alignCenter2 {
  text-align: center;
  padding-right: 45px;
  padding-left: 45px;
  padding-bottom: 0px;
}
.alignCenter3 {
  text-align: center;
  padding-right: 45px;
  padding-left: 45px;
  padding-top: 0px;
}
.resPadding {
  padding-right: 0px;
  padding-left: 0px;
}
.imgcenter {
  margin-left: auto;
  margin-right: auto;
}
/* .right { */
/* float: right; */
/* text-align: right */
/* width: 80%; */
/* width: 300px; */
/* border: 3px solid #73AD21; */
/* padding: 10px; */
/* } */
</style>